/* mtm-gift-wrap.js
 * 1) Når "Gaveindpakning" er valgt, lægges indpakningen i kurven i samme kald som varen
 *    (formularen omskrives til items[]-formatet lige før Prestiges product-form læser den).
 * 2) Rydder op i kurven: indpakning uden tilhørende vare fjernes, og antal kan ikke overstige varens.
 */
(() => {
  if (window.mtmGiftWrapLoaded) return;
  window.mtmGiftWrapLoaded = true;

  const WRAP_FOR = '_mtm_wrap_for';
  const WRAP_TITLE = 'Til';

  // 1) Tilføj indpakning ved "Føj til kurv"
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // NB: form.id peger på <input name="id">, så formularens id skal læses som attribut
    const formId = form.getAttribute('id');
    const action = form.getAttribute('action') || '';
    if (!formId || !/\/cart\/add/.test(action)) return;

    const checkbox = document.querySelector(`[data-mtm-gift-wrap][data-form="${CSS.escape(formId)}"]`);
    if (!checkbox || !checkbox.checked) return;

    const elements = Array.from(form.elements);
    const idEl = elements.find((el) => el.name === 'id' && !el.disabled);
    if (!idEl || !idEl.value) return;

    const qtyEl = elements.find((el) => el.name === 'quantity' && !el.disabled);
    const quantity = Math.max(1, parseInt(qtyEl?.value, 10) || 1);

    const moved = [];
    const added = [];
    const add = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
      added.push(input);
    };

    // Varen selv → items[0]
    add('items[0][id]', idEl.value);
    add('items[0][quantity]', String(quantity));

    elements.forEach((el) => {
      if (el.disabled || !el.name) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;

      let target = null;
      if (el.name === 'selling_plan' && el.value) target = 'items[0][selling_plan]';
      const match = el.name.match(/^properties\[(.+)\]$/);
      if (match && el.value !== '') target = `items[0][properties][${match[1]}]`;

      if (target) add(target, el.value);
      if (target || el.name === 'id' || el.name === 'quantity' || el.name === 'selling_plan') {
        el.disabled = true;
        moved.push(el);
      }
    });

    // Indpakningen → items[1]
    add('items[1][id]', checkbox.dataset.variantId);
    add('items[1][quantity]', String(quantity));
    add(`items[1][properties][${WRAP_TITLE}]`, checkbox.dataset.productTitle);
    add(`items[1][properties][${WRAP_FOR}]`, idEl.value);

    // Prestige bygger FormData synkront i sin submit-handler – gendan formularen bagefter
    setTimeout(() => {
      added.forEach((input) => input.remove());
      moved.forEach((el) => { el.disabled = false; });
    }, 0);
  }, true);

  // 2) Oprydning i kurven
  let busy = false;
  const cleanup = async (cart) => {
    if (busy || !cart || !Array.isArray(cart.items)) return;

    const totals = {};
    cart.items.forEach((item) => {
      if (!item.properties || !item.properties[WRAP_FOR]) {
        totals[item.variant_id] = (totals[item.variant_id] || 0) + item.quantity;
      }
    });

    const updates = {};
    const used = {};
    cart.items.forEach((item) => {
      const forId = item.properties && item.properties[WRAP_FOR];
      if (!forId) return;
      const allowed = Math.max(0, (totals[forId] || 0) - (used[forId] || 0));
      const qty = Math.min(item.quantity, allowed);
      used[forId] = (used[forId] || 0) + qty;
      if (qty !== item.quantity) updates[item.key] = qty;
    });

    if (!Object.keys(updates).length) return;

    busy = true;
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates })
      });
      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } finally {
      setTimeout(() => { busy = false; }, 500);
    }
  };

  document.addEventListener('cart:change', (event) => cleanup(event.detail?.cart));
})();
